"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const quill_blot_formatter_mobile_1 = __importDefault(require("quill-blot-formatter-mobile"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_quill_1 = __importStar(require("react-quill"));
const icons_1 = require("../../../../assets/icons");
const ModalExplain_1 = __importDefault(require("../../../../components/modal/ModalExplain"));
const Article_1 = __importDefault(require("../../../../networking/apis/Article"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const ImageBase = react_quill_1.Quill.import('formats/image');
// CODE BLOCK FIX BUG ALIGN-IMAGE NOT TRIGGER ONCHANGE FUNCTION
const ATTRIBUTES = [
    'alt',
    'height',
    'width',
    'style' // This is the added difference that needs to be saved properly
];
class CustomImage extends ImageBase {
    static formats(domNode) {
        return ATTRIBUTES.reduce((formats, attribute) => {
            const copy = { ...formats };
            if (domNode.hasAttribute(attribute)) {
                // @ts-ignore
                copy[attribute] = domNode.getAttribute(attribute);
            }
            return copy;
        }, {});
    }
    format(name, value) {
        if (ATTRIBUTES.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            }
            else {
                this.domNode.removeAttribute(name);
            }
        }
        else {
            super.format(name, value);
        }
    }
}
react_quill_1.Quill.register('formats/image', CustomImage);
//
react_quill_1.Quill.register("modules/blotFormatter", quill_blot_formatter_mobile_1.default);
react_quill_1.Quill.register('modules/maxlength', function (quill, options) {
    quill.on('text-change', function () {
        const textLength = quill.root.innerHTML.length;
        if (textLength > options.maxLength) {
            // quill.deleteText(options.maxLength, textLength - options.maxLength);
            quill.history.undo();
        }
    });
});
const Font = react_quill_1.default.Quill.import('formats/font');
Font.whitelist = ['hiragino', 'noto-serif-jp', 'noto-sans-jp', 'maru-gothic', 'shippori-mincho'];
react_quill_1.default.Quill.register(Font, true);
const QuillEditor = (props) => {
    const { defaultValue = '', onChange } = props;
    const refReactQuill = (0, react_1.useRef)();
    const refImageInput = (0, react_1.useRef)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        refImageInput.current = document.createElement("input");
        refImageInput.current.setAttribute("type", "file");
        refImageInput.current.setAttribute("accept", "image/png, image/jpeg, image/jpg, image/webp");
        refImageInput.current.onclick = function () {
            // @ts-ignore
            this.value = null;
        };
        refImageInput.current.onchange = async () => {
            if (refImageInput.current !== null && refImageInput.current?.files !== null) {
                const file = refImageInput.current?.files[0];
                if (!file)
                    return;
                const isValid = (0, helpler_1.validateFile)(file, 10, 'image');
                if (!isValid)
                    return;
                const form = new FormData();
                form.append('image', file);
                Article_1.default.uploadImage(form)
                    .then(response => {
                    if (refReactQuill.current) {
                        const range = refReactQuill.current.getEditorSelection();
                        range && refReactQuill.current.getEditor().insertEmbed(range.index, "image", response.data);
                    }
                })
                    .catch((_) => { });
            }
        };
        return () => {
            refImageInput.current?.remove();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        refReactQuill.current?.editor?.root.insertAdjacentHTML('afterbegin', defaultValue);
    }, []);
    const imageHandler = (0, react_1.useCallback)(() => {
        refImageInput.current?.click();
    }, []);
    const matchers = (0, react_1.useMemo)(() => [
        [Node.ELEMENT_NODE, function (content, delta) {
                if (content?.src?.includes('emoji') && !!content?.alt) {
                    delta.ops = [{
                            insert: content.alt
                        }];
                }
                else {
                    delta.ops = delta.ops.map((op) => {
                        return {
                            insert: op.insert
                        };
                    });
                }
                return delta;
            }]
    ], []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", null, `
                    .ql-container {
                        font-size: 15px;
                    }
                    .ql-toolbar {
                        border: none !important;
                        height: ${(0, scale_1.verticalScale)(77)}px;
                    }
                    .ql-editor {
                        color: #292A33;
                        font-size: ${(0, scale_1.moderateScale)(15)}px;
                        margin-bottom: ${(0, scale_1.verticalScale)(85)}px;
                        font-family: 'Hiragino Kaku Gothic ProN', 'San Serif', 'Serif', 'Narita Monospace', 'Monospace', 'Tahoma', 'Arial';
                        padding: 0px 16px;
                    }
                    .ql-container.ql-snow{ border: none !important;}
                    .ql-editor.ql-blank::before {
                        font-style: normal !important;
                        color: #C8C8C8;
                    }
                    .ql-picker {
                        background-color: #ffffff;
                        border: 1px solid #C8C8C8;
                        border-radius: 4px;
                        margin-bottom: 8px;
                    }
                    .ql-snow.ql-toolbar button,
                    .ql-snow .ql-toolbar button {
                        background-color: #ffffff;
                        border: 1px solid #C8C8C8;
                        border-radius: 4px;
                        margin-bottom: 8px;
                    }

                    .ql-picker.ql-font .ql-picker-label[data-value="hiragino"]::before, 
                    .ql-picker.ql-font .ql-picker-item[data-value="hiragino"]::before
                    {
                        font-family: "Hiragino Kaku Gothic ProN";
                        content: "Hiragino";
                    }
                    .ql-font-hiragino {
                        font-family: "Hiragino Kaku Gothic ProN";
                    }

                    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-sans-jp"]::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-sans-jp"]::before {
                        content: 'Noto Sans';
                        font-family: "Noto Sans JP";
                    }
                    .ql-font-noto-sans-jp {
                        font-family: "Noto Sans JP";
                    }

                    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="noto-serif-jp"]::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="noto-serif-jp"]::before {
                        content: 'Serif';
                        font-family: "Noto Serif JP";
                    }
                    .ql-font-noto-serif-jp {
                        font-family: "Noto Serif JP";
                    }

                    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="maru-gothic"]::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="maru-gothic"]::before {
                        content: 'Maru Gothic';
                        font-family: "Zen Maru Gothic";
                    }
                    .ql-font-maru-gothic {
                        font-family: "Zen Maru Gothic";
                    }

                    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="shippori-mincho"]::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="shippori-mincho"]::before {
                        content: 'Shippori Mincho';
                        font-family: "Shippori Mincho B1";
                    }
                    .ql-font-shippori-mincho {
                        font-family: "Shippori Mincho B1";
                    }

                    .ql-snow .ql-picker.ql-font {
                        width: 144px !important;
                        white-space: nowrap;
                    }
                    #button-support {
                        margin-left: 6px;
                        padding: 0 !important;
                        border: none;
                        background-color: transparent;
                        width: fit-content;
                    }
                `),
        react_1.default.createElement(react_quill_1.default
        // @ts-ignore
        , { 
            // @ts-ignore
            ref: refReactQuill, onChange: onChange, style: styles.editView, placeholder: '\u3054\u81EA\u7531\u306B\u304A\u66F8\u304D\u304F\u3060\u3055\u3044\u3002', modules: {
                toolbar: {
                    // container: [
                    //     ["bold", "italic", "underline"],
                    //     ["blockquote", "code-block"],
                    //     [{ font: Font.whitelist }],
                    //     [
                    //         { align: [] },
                    //         { list: "ordered" },
                    //         { list: "bullet" },
                    //         { indent: "-1" },
                    //         { indent: "+1" },
                    //     ],
                    //     ["image", "link", "video"],
                    // ],
                    container: '#toolbar',
                    handlers: {
                        image: imageHandler,
                    },
                },
                // Help clear style formatting when paste text to editor
                clipboard: { matchers, matchVisual: false, },
                blotFormatter: {},
                maxlength: { maxLength: 21845 },
                history: { delay: 0 },
            } }),
        react_1.default.createElement("div", { id: "toolbar", className: 'ql-toolbar ql-snow' },
            react_1.default.createElement("span", { className: "ql-formats" },
                react_1.default.createElement("button", { className: "ql-bold" }),
                react_1.default.createElement("button", { className: "ql-italic" }),
                react_1.default.createElement("button", { className: "ql-underline" })),
            react_1.default.createElement("span", { className: "ql-formats" },
                react_1.default.createElement("button", { className: "ql-blockquote" }),
                react_1.default.createElement("button", { className: "ql-code-block" })),
            react_1.default.createElement("span", { className: "ql-formats" },
                react_1.default.createElement("select", { className: "ql-font", defaultValue: 'hiragino' },
                    react_1.default.createElement("option", { value: 'hiragino' }),
                    react_1.default.createElement("option", { value: "noto-serif-jp" }),
                    react_1.default.createElement("option", { value: "noto-sans-jp" }),
                    react_1.default.createElement("option", { value: "maru-gothic" }),
                    react_1.default.createElement("option", { value: "shippori-mincho" })),
                react_1.default.createElement("button", { id: "button-support", onClick: () => setIsOpen(true) },
                    react_1.default.createElement(icons_1.IconQuestion, null))),
            react_1.default.createElement("span", { className: "ql-formats" },
                react_1.default.createElement("select", { className: "ql-align" }),
                react_1.default.createElement("button", { className: "ql-list", value: "ordered" }),
                react_1.default.createElement("button", { className: "ql-list", value: "bullet" }),
                react_1.default.createElement("button", { className: "ql-indent", value: "-1" }),
                react_1.default.createElement("button", { className: "ql-indent", value: "+1" })),
            react_1.default.createElement("span", { className: "ql-formats" },
                react_1.default.createElement("button", { className: "ql-image" }),
                react_1.default.createElement("button", { className: "ql-link" }),
                react_1.default.createElement("button", { className: "ql-video" }))),
        react_1.default.createElement(ModalExplain_1.default, { visible: isOpen, onClose: () => setIsOpen(false), title: "\u4E00\u90E8\u30D5\u30A9\u30F3\u30C8\u306E\u88C5\u98FE\u306B\u3064\u3044\u3066", boxStyle: {
                width: (0, scale_1.scale)(343),
            }, content: "\u30D2\u30E9\u30AE\u30CE\u306F\u30A4\u30BF\u30EA\u30C3\u30AF\u4F53\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u30A4\u30BF\u30EA\u30C3\u30AF\u4F53\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u306F\u4ED6\u306E\u30D5\u30A9\u30F3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002", contentStyle: { textAlign: 'center' } })));
};
exports.default = QuillEditor;
const styles = react_native_1.StyleSheet.create({
    editView: {
        flex: 1,
        marginTop: (0, scale_1.scale)(16),
        display: 'flex',
        flexDirection: 'column-reverse',
    },
});
